module.exports = __webpack_public_path__ + "static/img/sb03.1b9b83c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/intellectualProperty/sb03.png
// module id = Vi/D
// module chunks = 1